import { render } from "./submitted-activities.vue?vue&type=template&id=223117f2&scoped=true"
import script from "./submitted-activities.vue?vue&type=script&lang=js"
export * from "./submitted-activities.vue?vue&type=script&lang=js"

import "./submitted-activities.vue?vue&type=style&index=0&id=223117f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-223117f2"

export default script